import Styles from './Courses.module.scss'
import { CoursesCard } from 'components/CoursesCard/CoursesCard'
import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import axios from 'axios';
import Pagination from '@mui/material/Pagination';
import { ViewContext, AuthContext, useCan } from 'components/lib';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';

//icons
import SearchIcon from '@mui/icons-material/Search';

import CancelIcon from '@mui/icons-material/Cancel';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import FeatherIcon from 'feather-icons-react';

export function Courses() {
    const isArchivePage = window.location.pathname.split('/')[3] === "hidden"
    const [isLead, setIsLead] = useState(false)
    const [totalPages, setTotalPages] = useState()
    const [pageNumber, setPageNumber] = useState(1);
    const [courses, setCourses] = useState();
    const [loading, setLoading] = useState(false)
    const [cancelSearch, setCancelSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('')
    const viewContext = useContext(ViewContext);
    const authContext = useContext(AuthContext)
    const navigate = useNavigate();
    const permissionAll = useCan('lms.courseall.view')
    const permissionHidden = useCan('lms.course.hidden.view')

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            try {
                let pageURL;
                pageURL = `/api/lms/user/courses?pageNumber=${pageNumber}`
                if (isArchivePage) {
                    pageURL = `/api/lms/user/courses?status=hidden&pageNumber=${pageNumber}`
                }
                const response = await axios.get(pageURL);
                setTotalPages(response.data.totalPages ?? 1)
                setCourses(response.data.data)
                setIsLead(response?.data?.lmsLead ?? false)
                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error);
                viewContext.handleError(error);
                viewContext.notification.show('Error Fetching Courses', 'error');
                setLoading(false)
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber, isArchivePage]);

    const handlePageChange = (event, value) => {
        setPageNumber(value);
    };

    function onSearch(value) {
        let pageURL;
        pageURL = `/api/lms/user/courses?title=${value}`
        if (isArchivePage) {
            pageURL = `/api/lms/user/courses?title=${value}&status=hidden`
        }
        axios.get(pageURL)
            .then(response => {
                value !== '' ? setCancelSearch(true) : setCancelSearch(false);
                setCourses(response.data.data)
            })
            .catch(error => {
                console.error('Error:', error);
                viewContext.notification.show(error.message, 'error');
            });

    }

    function onEndSearch() {
        setSearchValue('');
        onSearch('');
        setCancelSearch(false);
    }

    return (
        <>
            <LoadingBackdrop
                isOpen={loading}
            />
            {courses ? <div className={Styles.ancestorContainer}>
                <span className={Styles.pageTitleContainer}>
                    <p
                        className={Styles.pageTitle}
                    >
                        Courses
                    </p>
                    <span className={Styles.myCourseButton}>
                        {!!isLead &&
                            <>
                                <p onClick={() => {
                                    if (isArchivePage) {
                                        navigate('/lms/courses/all')
                                    } else {
                                        navigate('/lms/courses/hidden')
                                    }
                                }}>
                                    {isArchivePage ? "Available Courses" : "Archived & Draft Courses"}
                                </p>
                                •
                            </>
                        }
                        <p onClick={() => { navigate('/lms/courses') }}>Go To My Courses</p>
                    </span>
                    {
                        (permissionAll && permissionHidden) && 
                        <AivagamButton
                            buttonText={
                                <>
                                    <FeatherIcon
                                        color='black'
                                        icon='plus'
                                    />
                                    Add Course
                                </>
                            }
                            onClick={() => {
                                navigate('/lms/course/create')
                            }}
                            icon
                            type='action'
                        />
                    }
                </span>
                <span className={Styles.BreadCrumbsContainer}>
                    <BreadCrumbs onClickPaths={['']} crumbs={isArchivePage ? ['Archived & Draft Courses'] : ['Available Courses']} />
                </span>
                <div className={Styles.mainContainer}>
                    <div className={Styles.searchAndPagination}>
                        <span className={Styles.searchContainer}>
                            <SearchIcon onClick={() => { searchValue !== '' ? onSearch(searchValue) : onSearch('') }} />
                            <input
                                type='text'
                                value={searchValue}
                                placeholder='Search...'
                                onChange={(e) => { setSearchValue(e.target.value) }}
                                onKeyDown={(e) => { e.key === 'Enter' && (searchValue !== '' ? onSearch(searchValue) : onSearch('')) }}
                            />
                            {cancelSearch && <CancelIcon onClick={onEndSearch} fontSize='small' sx={{ color: "#d3d3d3", mr: '0.2em' }} />}
                        </span>


                    </div>
                    <div className={Styles.coursesContainer}>
                        {
                            courses?.length > 0 ?
                                courses?.map((course, index) => (
                                    <CoursesCard
                                        key={`${course.id}`}
                                        data={course}
                                        onClick={() => {
                                            if (isArchivePage) {
                                                navigate(`/lms/course/${course?.id}/edit`)
                                            } else {
                                                navigate(`/lms/courses/${course?.id}`)
                                            }
                                        }}
                                        isArchivePage={isArchivePage}
                                    />
                                )) :
                                <p>No Courses Found</p>
                        }
                    </div>
                    <div className={Styles.paginationContainer}>
                        <Pagination
                            // size='small'
                            siblingCount={0}
                            count={totalPages}
                            color="primary"
                            variant='outlined'
                            onChange={handlePageChange}
                        />

                    </div>
                </div>
            </div> : <p style={{ fontSize: "22px" }}>No Courses Found</p>}
        </>
    )
}
